import { environment } from '../../environments/environment';

export interface FrontendHttpLog {
  event: string;
  requestId: string;
  method: string;
  endpoint: string;
  feature: string;
  durationMs?: number;
  statusCode?: number;
  failureType?: 'network' | 'http' | 'provider' | 'validation';
  messageId?: number;
  chatId?: number;
  tempId?: string;
  attempt?: number;
  fileSize?: number;
  mimeType?: string;
  progress?: number;
  errorCode?: string;
  errorMessage?: string;
}

export interface DashboardMediaUploadFailureReport {
  eventType: 'upload_failure' | 'client_rejection';
  requestId: string;
  messageId?: number;
  chatId?: number;
  tempId: string;
  attempt?: number;
  fileSize: number;
  mimeType: string;
  statusCode?: number;
  failureType: 'network' | 'http' | 'provider' | 'validation';
  durationMs?: number;
  progress?: number;
  errorCode?: string;
  errorMessage?: string;
}

export function isBackendRequest(url: string): boolean {
  try {
    const base = new URL(environment.apiHost);
    const target = new URL(url, base.origin);
    return target.origin === base.origin;
  } catch {
    return false;
  }
}

export function logFrontendHttpEvent(event: FrontendHttpLog): void {
  const entry = {
    category: 'http',
    source: 'frontend',
    correlationId: event.requestId,
    ...event,
  };
  if (
    event.event === 'http.request.failed' ||
    event.event === 'http.request.cancelled' ||
    event.event === 'dashboard.media_upload.rejected' ||
    event.event === 'dashboard.media_upload.report.failed'
  ) {
    console.error(entry);
  } else {
    console.info(entry);
  }
}
